import React from 'react';

type ServiceCommandCenterLayoutProps = {
  mode: 'mobile' | 'desktop';
  mobile: React.ReactNode;
  desktop: React.ReactNode;
};

export const ServiceCommandCenterLayout: React.FC<ServiceCommandCenterLayoutProps> = ({
  mode,
  mobile,
  desktop,
}) => (
  <div
    className="rs-command-center"
    data-command-center-mode={mode}
    data-testid="service-command-center-layout"
  >
    {mode === 'desktop' ? desktop : mobile}
  </div>
);

export default ServiceCommandCenterLayout;
